import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d39a32d2")

_pushScopeId("data-v-d39a32d2")
const _hoisted_1 = { class: "valid_tickets" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, "Valid & unused tickets", -1)
const _hoisted_3 = {
  key: 0,
  class: "loading_data_spinner"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm mr-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Loading . . . ")
const _hoisted_6 = { class: "tickets_arrows" }
const _hoisted_7 = { class: "zero-ticket" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "period" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "straight-icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 30 30"
  }, [
    /*#__PURE__*/_createVNode("g", {
      id: "Group_147",
      "data-name": "Group 147",
      transform: "translate(-527 -353)"
    }, [
      /*#__PURE__*/_createVNode("g", {
        id: "Ellipse_35",
        "data-name": "Ellipse 35",
        transform: "translate(527 353)",
        fill: "none",
        stroke: "#487fff",
        "stroke-width": "3"
      }, [
        /*#__PURE__*/_createVNode("circle", {
          cx: "15",
          cy: "15",
          r: "15",
          stroke: "none"
        }),
        /*#__PURE__*/_createVNode("circle", {
          cx: "15",
          cy: "15",
          r: "13.5",
          fill: "none"
        })
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "Ellipse_36",
        "data-name": "Ellipse 36",
        transform: "translate(533 359)",
        fill: "none",
        stroke: "#487fff",
        "stroke-width": "3"
      }, [
        /*#__PURE__*/_createVNode("circle", {
          cx: "9",
          cy: "9",
          r: "9",
          stroke: "none"
        }),
        /*#__PURE__*/_createVNode("circle", {
          cx: "9",
          cy: "9",
          r: "7.5",
          fill: "none"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("svg", {
    class: "broken_lines",
    xmlns: "http://www.w3.org/2000/svg",
    width: "3",
    height: "40",
    viewBox: "0 0 3 70"
  }, [
    /*#__PURE__*/_createVNode("line", {
      id: "Line_22",
      "data-name": "Line 22",
      y2: "70",
      transform: "translate(1.5)",
      fill: "none",
      stroke: "#487fff",
      "stroke-width": "3",
      "stroke-dasharray": "10"
    })
  ]),
  /*#__PURE__*/_createVNode("svg", {
    id: "map-pin-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 32 32"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_79",
      "data-name": "Path 79",
      d: "M0,0H32V32H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_80",
      "data-name": "Path 80",
      d: "M16,27.859l7.15-6.773a9.224,9.224,0,0,0,0-13.544,10.514,10.514,0,0,0-14.3,0,9.224,9.224,0,0,0,0,13.544Zm0,3.869L6.808,23.021a11.859,11.859,0,0,1,0-17.414,13.518,13.518,0,0,1,18.385,0,11.859,11.859,0,0,1,0,17.414ZM16,17.05a2.816,2.816,0,0,0,2.889-2.736,2.893,2.893,0,0,0-5.778,0A2.816,2.816,0,0,0,16,17.05Zm0,2.736a5.631,5.631,0,0,1-5.778-5.473A5.631,5.631,0,0,1,16,8.841a5.631,5.631,0,0,1,5.778,5.473A5.631,5.631,0,0,1,16,19.786Z",
      transform: "translate(0 0)",
      fill: "#487fff"
    })
  ])
], -1)
const _hoisted_11 = { class: "places" }
const _hoisted_12 = { class: "company_logo" }
const _hoisted_13 = { class: "font-italic" }
const _hoisted_14 = { class: "ticket-options" }
const _hoisted_15 = { class: "scan_map" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" scan ")
const _hoisted_17 = /*#__PURE__*/_createVNode("svg", {
  id: "qr-code-line",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }),
  /*#__PURE__*/_createVNode("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M16,17V16H13V13h3v2h2v2H17v2H15v2H13V18h2V17Zm5,4H17V19h2V17h2ZM3,3h8v8H3ZM5,5V9H9V5Zm8-2h8v8H13Zm2,2V9h4V5ZM3,13h8v8H3Zm2,2v4H9V15Zm13-2h3v2H18ZM6,6H8V8H6ZM6,16H8v2H6ZM16,6h2V8H16Z",
    fill: "#fff"
  })
], -1)
const _hoisted_18 = { class: "sell_option" }
const _hoisted_19 = { class: "money" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.$store.state.Booking.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.text), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unused, (ticket) => {
        return (_openBlock(), _createBlock("div", {
          class: "ticket",
          key: ticket
        }, [
          _createVNode("div", _hoisted_8, [
            _createVNode("p", null, _toDisplayString(ticket.time), 1),
            _createVNode("p", _hoisted_9, _toDisplayString(ticket.date), 1)
          ]),
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode("p", null, _toDisplayString(ticket.departure), 1),
            _createVNode("p", null, _toDisplayString(ticket.destination), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("p", _hoisted_13, _toDisplayString(ticket.buscompany), 1)
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("p", {
                onClick: ($event: any) => (_ctx.$store.commit('Booking/scanThisTicket', ticket))
              }, [
                _hoisted_16,
                _hoisted_17
              ], 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("p", _hoisted_19, _toDisplayString(ticket.price) + " Frw", 1)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
})